import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=50e04f1a"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=50e04f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports